export class GroupSelect {
  label: string = ''
  items: any = []
}

export const baseURL: string = process.env.REACT_APP_API!
export const ChronosAuth: string =
  'O9EvCZbQ/z/KgOjsan2szDT6872fHXjOTWfzylieglKWmLlVpSn4ruRnbZ6jtK1HoCe6E2ebqq3tEz0YHbedjgrP7uE/1nR222goYFaqx8KxGvPBo+FKC74sAiNrvJFlUm9kAsEHEl5xrmAU7GyiFxetj9BYdPslk30kq2WvxlU=PrometheusEncryptionkUsaFEOV62TUc54Mx/CDAjze0k/O5TZ68A5mzOBd6HNYYbtXTZ1LGorTRDpfbzy6kCGOdgQaGtUHerd+0svjL9ttRi+LodWad3UljY5BDtVSuUpsizX8LnV5H3YLGeUcRzMBs7O7Jr6env7pG1B02wb4y48l0Rin7akpdH6VnLI='
export const WebApiKey: string =
  'F1jhg6dK9W19LS4SopS4SuN6PHtgWHWLTFsYe5uQi+mdNwVDt8GP+VS95GvQTuqZXH0uG2LfWjSmjrJowkQuPeLO+QbSPzXfBykH4OOa9LWyWngjZdClHysH0ngzNSPyet+xaa6eRXQHl/aXMsJBF1lpAK6TP1CmQ8P6+1yM9Tk='

export enum PlanTypes {
  HomeOffice = 1,
  TableReservation = 2,
  TableFloorReservation = 5,
  Vacant = 3,
  OtherLocationTableReservation = 4,
  OtherLocationTableFloorReservation = 6,
  DayOff = 7,
  Leave = 20,
  MedicalCertificate = 21,
  CampusService = 100,
  Health = 101,
  Coiffeur = 102,
  GymSaloon = 103,
  GymGroupLesson = 104,
  GymTrainer = 105,
  LactationRoom = 106,
  ParkArea = 107,
  MeetingRoom = 108,
  PoolVehicle = 111,
}

export enum TransactionResponseTypes {
  Success = 1,
  NonAdmin = 2,
  HasChildRecords = 3,
  Fail = 4,
}

export enum AuthTypes {
  OFFICE = 'OFFICE',
  REMOTE = 'REMOTE',
  COMMON = 'COMMON',
  CAMPUS = 'CAMPUS',
}

export enum CampusAuthTypes {
  HEALTH = 'HEALTH',
  GYM = 'GYM',
  COIFFEUR = 'COIFFEUR',
  LACTATION = 'LACTATION',
  PARK = 'PARK',
  MEETING = 'MEETING',
  POOL = 'POOL_VEHICLE',
}

export enum ReservationStatuses {
  PendingApproval = 1,
  Approved = 2,
  Rejected = 3,
}
